let storeTitle = "";
let routerTitle = "";

function setTitle() {
  if (!storeTitle && !routerTitle) {
    document.title = "Jsite";
  } else if (!storeTitle) {
    document.title = routerTitle;
  } else if (!routerTitle) {
    document.title = storeTitle;
  } else {
    document.title = routerTitle + " - " + storeTitle;
  }
}
export default {
  setRouterTitle(title) {
    routerTitle = title;
    setTitle();
  },
  setStoreTitle(title) {
    storeTitle = title;
    setTitle();
  },
};
